// some helper function for modify quiz Section data structure,
// array , object operation

export const quizFormInputSetStateCallback = (identifier, value) =>
    (prev) => {
        const isExist = prev.some(item => ((item?.identifier?.quizId === identifier?.quizId) && (item?.identifier?.optionId === identifier.optionId)))

        // if exist already
        if (isExist) {
            return prev.map(item => {

                if ((item.identifier.quizId === identifier.quizId) && (item.identifier.optionId === identifier.optionId)) {
                    // target property update
                    return { ...item, answer: value }
                } else {
                    return item
                }
            })
        }
        // if no exist 
        else {
            return [...prev, { identifier, answer: value }]
        }

    }




